import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { CmsLink as Link, EditableText } from '../content/EditableText';
import { useCmsContent } from '../content/CmsContentContext';

const Therapists = () => {
  const { content } = useCmsContent();
  const { therapists } = content;

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-brand-700 to-brand-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-light mb-4"><EditableText contentKey="pages.therapists.heroTitle" /></h1>
          <p className="text-xl max-w-3xl mx-auto">
            <EditableText contentKey="pages.therapists.heroBody" />
          </p>
        </div>
      </section>

      {/* Therapists Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {therapists.map((therapist, therapistIndex) => (
              <div
                key={therapist.id}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <div className="md:flex">
                  <div className="md:flex-shrink-0">
                    <img
                      src={therapist.image}
                      alt={therapist.name}
                      className="h-64 w-full md:w-48 object-cover"
                    />
                  </div>
                  <div className="p-8">
                    <div className="uppercase tracking-wide text-sm text-brand-700 font-semibold">
                      <EditableText contentKey={`therapists.${therapistIndex}.title`} />
                    </div>
                    <h2 className="mt-2 text-2xl font-semibold text-gray-900"><EditableText contentKey={`therapists.${therapistIndex}.name`} /></h2>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {therapist.specialties.map((specialty, index) => (
                        <span
                          key={index}
                          className="inline-block bg-brand-100 text-brand-800 text-xs px-2 py-1 rounded"
                        >
                          <EditableText contentKey={`therapists.${therapistIndex}.specialties.${index}`} multiline={false} />
                        </span>
                      ))}
                    </div>
                    <p className="mt-4 text-gray-600"><EditableText contentKey={`therapists.${therapistIndex}.bio`} /></p>
                    <div className="mt-4 space-y-1 text-sm text-gray-500">
                      <p><EditableText contentKey={`therapists.${therapistIndex}.education`} /></p>
                      <p><EditableText contentKey={`therapists.${therapistIndex}.license`} /></p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-brand-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-light text-gray-900 mb-6">
            <EditableText contentKey="pages.therapists.ctaTitle" />
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            <EditableText contentKey="pages.therapists.ctaBody" />
          </p>
          <Link
            to="/book-appointment"
            className="inline-flex items-center px-8 py-3 bg-brand-700 text-white rounded-md hover:bg-brand-800 transition-colors text-lg font-medium"
          >
            <EditableText contentKey="pages.therapists.ctaButton" multiline={false} /> <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Therapists;
